import { Tooltip } from "@mui/material";
import React, { useContext } from "react";
import { CartContext } from "../POS";
import { ReportProblemRounded } from "@mui/icons-material";

const OutOfStockInvError = ({ item }) => {
  const { setCartData } = useContext(CartContext);

  const handleSkipInvError = (e) => {
    e.stopPropagation();
    setCartData((j) => ({
      ...j,
      sellItems: j.sellItems.map((x) =>
        x.key === item.key ? { ...x, outOfStock: false } : x
      ),
    }));
  };

  return (
    <div>
      <Tooltip
        onClick={handleSkipInvError}
        title={
          <span className="text-red-400 font-bold">
            {item.invMsg} | click here the continue sale
          </span>
        }
      >
        <ReportProblemRounded className="" fontSize="medium" color="error" />
      </Tooltip>
    </div>
  );
};

export default OutOfStockInvError;
